import { IHoldingMessageProps } from './HoldingMessage';

export const EdataHoldingInfo: IHoldingMessageProps = {
  title: 'Edata',
  sections: [
    {
      heading: 'What is Edata?.',
      body: 'EDATA is a cloud-based data pool that allows manufacturers to share product information with Electrical wholesalers and distributors.',
    },
  ],
};
